/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import _ from "underscore";
import * as DocumentService from "../../../../secure/services/documentService";

const Footer = () => {
  const [callCount, setCallCount] = useState(1);

  useEffect(() => {
    if (callCount === 1) {
      setCallCount(0);
      getFooterDetails();
    }
  }, []);

  const getFooterDetails = async () => {
    try {
      const response = await DocumentService.getFooter();
      if (response.status === 200) {
        if (!_.isEmpty(response.data.result)) {
          // Convert the HTML string into a document object
          var parser = new DOMParser();
          var html = parser.parseFromString(
            `<p class="footer_text">${response.data.result}</p>`,
            "text/html"
          );

          var element = html.querySelector("p");
          const footer = document.getElementById("main_footer");
          footer.innerHTML = "";
          footer.appendChild(element);
        }
      }
    } catch (e) {}
  };

  return <footer id="main_footer"></footer>;
};

export default Footer;
